import Chip from '@mui/material/Chip';

interface Props {
  readonly children: string;
}

export const SecondaryWrapper = ({ children }: Readonly<Props>) => (
  <Chip label={children} size="small" />
);
